export function getCurrentYear(): number {
  return new Date().getFullYear();
}

export function getAppTitle(language: "en" | "zh"): string {
  if (language === "zh") {
    return "聯招幫幫";
  }

  return `${getCurrentYear()} JUPAS Analyser`;
}